import { jsx } from "react/jsx-runtime";
import AntInputNumber from "antd/es/input-number";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import './InputNumber.css';/* empty css                 */
const InputNumber = ({
  className,
  placeholder = "Введите",
  upHandler = /* @__PURE__ */ jsx(Icon, { name: "left", size: 14 }),
  downHandler = /* @__PURE__ */ jsx(Icon, { name: "right", size: 14 }),
  controls,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntInputNumber,
    {
      className: classnames(
        [
          "perxis-auto-input-number",
          {
            "perxis-auto-input-number--no-controls": !controls
          }
        ],
        className
      ),
      placeholder,
      upHandler,
      downHandler,
      controls,
      ...props
    }
  );
};
export {
  InputNumber as default
};
//# sourceMappingURL=InputNumber.js.map
